 $(document).ready(function(){
   setTimeout(function(){
    pro_swatches();     
   },500)
   
   $(".product-form__input input[type=radio]").change(function(){
       $(".product__info-container .product-form__input").each(function(){
    var selectedval = $(this).find("input:checked").val();
         $(this).find(".c_p-swatch-selected-val").html(selectedval);
         console.log("k-----------", selectedval);
  });
    });
   
  });
  
  $(document).ready(function(){
  $('.u_radio_btn').change(function(){
    pro_swatches()
  })
  })
   function pro_swatches(){
    let final ='';
    let comb= '';
    $('.u_radio_btn:checked').each(function(){
      let checked_val= $(this).val();
      comb += checked_val + ' / '
    })
    console.log(comb)
    var finall =comb.slice(0 ,comb.length-2).trim();
    console.log('--final combination',finall);

    let flag=false;
    $(".u_master_select option").each(function(){
      var word =$(this).attr('data-title').trim();
      if(word == finall){
        console.log('---',word);
        flag =true;
      }
    });
    if(flag==true)
    {
      //master select
      $(".u_master_select option").each(function(){
        if($(this).attr('data-title').trim() == finall){
          $('.u_master_select').val($(this).val()).trigger('change');         
          // variant change price
          var variant_price = $(this).attr('price-data');
          console.log('variant price',variant_price);
          $('.u_price').text(Shopify.formatMoney(variant_price));
          let compare_variant_price = $(this).attr('compare-price-data');
          console.log('cvariant price',compare_variant_price);
          $('.u_cprice').text(Shopify.formatMoney(compare_variant_price));
          let variant_id =  $(this).attr('value');
           history.pushState({}, '','?variant='+variant_id);
           let var_policy = $(this).attr('var-policy')
      let var_manag = $(this).attr('var-manag')
          let var_qty = parseInt($(this).attr('data-iq'));
          $('.product-variant-id').val(variant_id)
          if(typeof compare_variant_price != 'undefined'){
            let u_minus = compare_variant_price - variant_price;
            console.log('u minus' ,u_minus)
            let f_per = (u_minus / compare_variant_price  )*100;
             console.log('f_per' ,f_per)
            let ff_prer = Math.round(f_per)
                        $('.u_off_price').show()
            $('.u_off_price').text(`SPAR  ${ff_prer}%`)
          }
          else{
            $('.u_off_price').hide()
          }
           if(var_policy == 'deny' && var_manag == 'shopify'){
      if(var_qty > 0){
      console.log('quantity > 0')
              $('.u_pro_atc_text').text('Tilføj til kurv');
      $('.u_pro_atc_btn').attr('var-id',variant_id).prop("disabled", false)
      }
      else{
              console.log('quantity < 0')
              $('.u_pro_atc_text').text('sold out')
            $('.u_pro_atc_btn').attr('var-id',variant_id).prop("disabled", true)
      }
    }
    else{
                    console.log('quantity < 0 and contimue')
              $('.u_pro_atc_text').text('Tilføj til kurv');
        $('.u_pro_atc_btn').attr('var-id',variant_id).prop("disabled", false)
    }
        }
        });
        }
    else{
        $('.u_pro_atc_text').text('Unavailable')
        $('.u_pro_atc_btn').prop("disabled", true)
      console.log(' combination does not exists');
    }
  }
  async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
  $(function(){
    $('.u_accordian_head').click(function(){               
            $(this).next('.u_accordian_body').toggleClass('active').slideToggle();
            $(this).find('.u_icon').toggleClass('u_icon_hide');
            })
     $(".u_addon_clr").click(function(){
    $(this).parent().find(".u_addon_clr").removeClass("u_custom_active_addon");
    $(this).addClass("u_custom_active_addon");
    var color_name = $(this).attr('data-clr').trim();
    let img = $(this).parents(".u_addon_pro_block").find(".u_addon_img_size");
         let a = $(this).parents(".u_addon_pro_block").find(".u_addon_pro_link");
  $(this).parents('.u_addon_pro_block').find(".custom-master-select option").each(function(i){
      if($(this).attr('var_title').indexOf(color_name) != -1){
         a.attr("href", $(this).val());
        $('.u_addon_pro_btn_size').attr('var_id',$(this).attr('var_id'))
        if($(this).attr("data-img") != "none"){
          img.attr("src", $(this).attr("data-img"));
        }
      }
    });
  });
    $('.u_custom_active_addon').trigger('click')

              })